import React, { useState } from 'react'
import $t from '../../../../i18n'
import { useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import Page from '../../../common/Page/Page'
import ActionButton from '../../../common/ActionButton'

import './SexSelectPage.css'

export const SexSelectPage = ({ onNext }) => {
  const dispatch = useDispatch()
  const [sex, setSex] = useState()

  const sexOptions = {
    male: 'male',
    female: 'female',
  }

  const onSexSelected = sex => {
    setSex(sex)
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.CHOOSE_SEX_CLICKED,
        data: { sex },
      })
    )
    dispatch(Actions.createAction(Actions.UPDATE_SEX_REQUESTED, { sex }))

    // on next comes from wizard component
    // we can use this component without the wizard and and 'onnext' will be undefined
    if (onNext) {
      onNext()
    }
  }
  return (
    <Page title={$t('sexSelectPage.title')}>
      <div className="sex-page-container">
        <ActionButton
          label={$t('sexSelectPage.female')}
          iconName="female"
          isVertical
          size={38}
          className="female-action sex-action trackable"
          data-selected={sex === sexOptions.female}
          onPress={() => onSexSelected(sexOptions.female)}
        />
        <ActionButton
          label={$t('sexSelectPage.male')}
          iconName="male"
          isVertical
          size={38}
          className="female-action sex-action trackable"
          data-selected={sex === sexOptions.male}
          onPress={() => onSexSelected(sexOptions.male)}
        />
      </div>
    </Page>
  )
}

export default SexSelectPage
